import { hvacConfig } from './hvac';
import { localConfigs } from './local';
import { regionConfigs } from './local-regions';
import type { NicheConfig } from './types';

export const niches: Record<string, NicheConfig> = {
  hvac: hvacConfig,
  ...Object.fromEntries(localConfigs.map((c) => [c.slug, c])),
  ...Object.fromEntries(regionConfigs.map((c) => [c.slug, c])),
};

export type { NicheConfig };
